module.exports = __webpack_public_path__ + "components/country-flag/static/pf-33cc77458deedb030ef187f8165c059e.svg";